import ActionsCell from './ActionsCell';

export default ActionsCell;
